import type React from "react";
import { useId } from "react";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	name: string;
	label: string | React.ReactNode;
	value?: string;
	checked?: boolean;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	required?: boolean;
	invalid?: boolean;
}

export const Checkbox = ({
	name,
	label,
	value = "1",
	checked = false,
	onChange = () => {},
	required = false,
	invalid = false,
	...extraInputProps
}: CheckboxProps) => {
	const id = useId();
	return (
		<div className="flex items-start gap-2">
			<input
				className="accent-primary h-5 w-5 translate-y-px shrink-0"
				id={id}
				name={name}
				value={value}
				checked={
					extraInputProps.defaultChecked !== undefined ? undefined : checked
				}
				aria-label={name}
				onChange={onChange}
				type="checkbox"
				{...extraInputProps}
			/>
			<label htmlFor={id}>
				{label}
				{required ? (
					""
				) : (
					<span className="ml-1 text-secondary-500">(optional)</span>
				)}
			</label>
		</div>
	);
};
